import { useState } from 'react';
import { DarkMode, LightMode, SystemMode } from '../icons';
import { LOCAL_STORAGE_NAMES, ThemeMode } from '../../constants/constants';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../context/ThemeContext';
import { themes } from '../config/variables';
import PreviewOptionGroup, { IPreviewOption } from '../previewOptionGroup/previewOptionGroup';

interface IThemeSwitcherProps {
  onSubmit?: () => void;
}

const ThemeSwitcher = ({ onSubmit }: IThemeSwitcherProps) => {
  const { t } = useTranslation();
  const [selectedTheme, setSelectedTheme] = useState<string>(
    localStorage.getItem(LOCAL_STORAGE_NAMES.theme) ?? ThemeMode.system.toLowerCase(),
  );
  const [, setThemeColor] = useTheme();

  const themeOptions: IPreviewOption<string>[] = [
    {
      value: ThemeMode.light.toLowerCase(),
      label: t('common:profile.theme.light'),
      preview: <LightMode />,
      testId: 'theme-light',
    },
    {
      value: ThemeMode.dark.toLowerCase(),
      label: t('common:profile.theme.dark'),
      preview: <DarkMode />,
      testId: 'theme-dark',
    },
    {
      value: ThemeMode.system.toLowerCase(),
      label: t('common:profile.theme.system'),
      preview: <SystemMode />,
      testId: 'theme-system',
    },
  ];

  const handleThemeChange = (value: string) => {
    const theme = value as keyof typeof themes;

    setSelectedTheme(theme);
    localStorage.setItem(LOCAL_STORAGE_NAMES.theme, theme);
    setThemeColor(theme);

    onSubmit?.();
  };

  return (
    <PreviewOptionGroup
      title={t('common:profile.theme.title')}
      options={themeOptions}
      value={selectedTheme}
      onChange={handleThemeChange}
      testId="theme-radio"
    />
  );
};

export default ThemeSwitcher;
